<div class="customers" *ngIf="componente===''">
    <div class="card">
        <div class="card-body" style="padding: 20px;">
            <div class="row" style="padding: 1rem;">
                <div class="col-sm-6" style="padding: 1rem;">
                    <p style="text-align: left;
                        font: normal normal bold 26px/53px Montserrat;
                        letter-spacing: 0px;
                        color: #00B09E;
                        opacity: 1;">Etapa 4: Plan de Mejoramiento Educativo</p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;"><b></b></p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">En esta sección podrá registrar el Plan de Mejoramiento Educativo, instancia de planificación que permite a la comunidad educativa organizar de manera sistémica e integrada los objetivos, metas, estrategias y acciones que permitan
                        consolidar los procesos de mejoramiento avanzando en el desarrollo de la calidad de la práctica educativas que favorezcan los aprendizajes y el desarrollo pleno e integral de todos los niños y niñas.</p><br>
                    <div class="col-sm-12">
                        <div class="card-header">
                            <div class="row">
                                <p class="data-card-info">Identificación de la Institución</p>
                                <table class="table-info">
                                    <tr>
                                        <td>
                                            <p class="table-row-title">Nombre:</p>
                                        </td>
                                        <td>Junta Nacional de Jardines Infantiles

                                        </td>
                                    </tr>
                                    <tr class="table-tr-shadow">
                                        <td>
                                            <p class="table-row-title">Sitio Web:</p>
                                        </td>
                                        <td>www.junji.gob.cl

                                        </td>
                                    </tr>
                                    <tr class="table-tr-shadow">
                                        <td>
                                            <p class="table-row-title">Dirección:</p>
                                        </td>
                                        <td>Morandé 226, Santiago Centro, región Metropolitana de Santiago.

                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" style="padding: 1rem;">
                    <div class="card-header" style="height: 100%;">
                        <div class="row">
                            <p class="data-card-info">Identificación de la Unidad Educativa</p>
                            <table class="table-info">
                                <tr>
                                    <td>
                                        <p class="table-row-title">Código:</p>
                                    </td>
                                    <td>{{uniEducativa.rbd}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Nombre:</p>
                                    </td>
                                    <td>{{uniEducativa.nombreJardin}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Programa:</p>
                                    </td>
                                    <td>{{uniEducativa.programa}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Modalidad:</p>
                                    </td>
                                    <td>{{uniEducativa.modalidad}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Teléfono:</p>
                                    </td>
                                    <td>{{uniEducativa.telefono}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Dirección:</p>
                                    </td>
                                    <td>{{uniEducativa.direccion}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Comuna:</p>
                                    </td>
                                    <td>{{uniEducativa.comuna}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Región:</p>
                                    </td>
                                    <td>{{uniEducativa.region}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-3">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="fase-estrategica">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="estadoPlanMejora >= 156 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Fase Estratégica PME</p>
                            <button type="button" (click)="irA('fase-estrategica')" class="btn btn-light btn-ver" *ngIf="estadoPlanMejora >= 156">VER</button>
                            <button type="button" (click)="irA('fase-estrategica')" class="btn btn-light btn-send" *ngIf="estadoGeneralUE.idTablaMaestra == 38 && estadoPlanMejora <156">INICIAR</button>
                            <button type="button" class="btn btn-light btn-send" *ngIf="estadoGeneralUE.idTablaMaestra != 38" disabled>INICIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="fase-anual">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="estadoPlanMejora > 157 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Fase Anual PME</p>
                            <button type="button" (click)="irA('fase-anual')" class="btn btn-light btn-ver" *ngIf="estadoPlanMejora > 157">VER</button>
                            <button type="button" (click)="irA('fase-anual')" class="btn btn-light btn-send" disabled *ngIf="estadoPlanMejora < 156">INICIAR</button>
                            <button type="button" (click)="irA('fase-anual')" class="btn btn-light btn-send" *ngIf="estadoPlanMejora == 156 || estadoPlanMejora == 157">INICIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="descargar-pme">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="estadoPlanMejora >= 156 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Descargar PME</p>

                            <button title="PDF" class="btn btn-light btn-send" *ngIf="estadoPlanMejora >= 156">
                                <a (click)="imprimir()" style="color: #ffffff;" target="_blank">PDF</a>
                            </button>
                            <button title="EXCEL" class="btn btn-light btn-send" *ngIf="estadoPlanMejora >= 156">
                                <a [attr.href]="urlInformeExcelPME" style="color: #ffffff;" target="_blank">EXCEL</a>
                            </button>

                            <button title="PDF" class="btn btn-light btn-send" *ngIf="estadoPlanMejora < 156" disabled>
                                <a (click)="imprimir()" style="color: #ffffff;" target="_blank">PDF</a>
                            </button>

                            <button title="EXCEL" class="btn btn-light btn-send" *ngIf="estadoPlanMejora < 156" disabled>
                                <a [attr.href]="urlInformeExcelPME" style="color: #ffffff;" target="_blank">EXCEL</a>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="seguimiento-pme">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="estadoPlanMejora > 159 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Seguimiento PME</p>
                            <button type="button" (click)="irA('fase-anual-seguimiento')" class="btn btn-light btn-ver" *ngIf="estadoPlanMejora > 159">VER</button>
                            <button type="button" class="btn btn-light btn-send" disabled *ngIf="!habilitarSeguimiento()">INICIAR</button>
                            <button type="button" (click)="irA('fase-anual-seguimiento')" class="btn btn-light btn-send" *ngIf="habilitarSeguimiento() && estadoPlanMejora <= 159">INICIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
</div>


<app-fase-estrategica [simulacion]="simulacion" *ngIf="componente==='fase-estrategica'"></app-fase-estrategica>
<app-fase-anual [simulacion]="simulacion" *ngIf="componente==='fase-anual'"></app-fase-anual>
<app-fase-anual-seguimiento [simulacion]="simulacion" *ngIf="componente==='fase-anual-seguimiento'"></app-fase-anual-seguimiento>


<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Plan de Mejoramiento Educativo</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>